<div class="mb-27 mct-flex mct-row mct-justify-between mct-items-start"  >
  <h4>{{ 'profiles.view.tasks.label' | translate | titlecase }}</h4>
  <div class="mct-flex mct-row mct-justify-between mct-items-center mct-gap-27" *ngIf="profileTasksTabFullAccess"   >
    <a [hidden]="!hasProjects" (click)="taskGenerate.open(profileId)">{{ 'profiles.view.tasks.generate-tasks' | translate | titlecase }}</a>
    <a (click)="taskEditDialog.initWithProfile(profileId); taskEditDialog.open()">{{
      'profiles.view.tasks.add-a-task' | translate | titlecase
    }}</a>
  </div>
</div>
<p-table [showGridlines]="true" [lazy]="true" [value]="searchResult?.Result" [sortField]="'DateDue'" [paginator]="true" [totalRecords]="searchResult?.TotalCount" [rows]="searchParams ? searchParams.PageSize : 10" (onLazyLoad)="lazyLoad($event)">
  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    <SortAltIcon *ngIf="sortOrder === 0">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
    </SortAltIcon>
    <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
    </SortAmountUpAltIcon>
    <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
    </SortAmountDownIcon>
  </ng-template>
  <ng-template pTemplate="header">
    <tr class="mct-hide-lt-md" >
      <th [pSortableColumn]="'Descr'">
        {{ 'profiles.view.tasks.description' | translate | titlecase }}
        <p-sortIcon></p-sortIcon>
      </th>
      <th [pSortableColumn]="'DateDue'" pSortableColumn="DateDue" style="width: 125px">
        {{ 'profiles.view.tasks.date-due' | translate | titlecase }}
        <p-sortIcon></p-sortIcon>
      </th>
      <th [pSortableColumn]="'AssignedToUserName'" pSortableColumn="AssignedToUserName" style="width: 170px">
        {{ 'profiles.view.tasks.assigned-to' | translate | titlecase }}<p-sortIcon></p-sortIcon>
      </th>
      <th [pSortableColumn]="'Closed'" style="width: 90px">
        {{ 'common.done' | translate | titlecase }}<p-sortIcon></p-sortIcon>
      </th>
      <th *ngIf="profileTasksTabFullAccess" style="width: 100px"></th>
    </tr>
    <tr class="mct-hide-gt-sm" >
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-task>
    <tr class="mct-hide-lt-md" >
      <td>
        {{ task.Descr }}
      </td>
      <td [ngClass]="{ 'past-due': task.Late }">{{ task.DateDue | date : 'M/d/yyyy' }}</td>
      <td>{{ task.AssignedToUserName }}</td>
      <td class="t-ac">
        <p-checkbox disabled binary="true" [(ngModel)]="task.Closed"></p-checkbox>
      </td>
      <td *ngIf="profileTasksTabFullAccess">
        <div class="mct-flex mct-justify-between mct-items-stretch" >
          <a class="light-text" (click)="deleteTask(task.TaskId)">{{ 'common.delete' | translate | titlecase }}</a>
          •
          <a (click)="taskEditDialog.open(task.TaskId)">{{ 'common.edit' | translate | titlecase }}</a>
        </div>
      </td>
    </tr>
    <tr class="mct-hide-gt-sm" >
      <td>
        <div   class="mb-12 mct-flex mct-row mct-justify-between mct-items-stretch">
          <div class="f-wb">
            {{ task.Descr }}
          </div>
          <div>{{ (task.Complete ? 'profiles.view.tasks.complete' : '') | translate | titlecase }}</div>
        </div>
        <div   class="mb-6 mct-flex mct-col mct-justify-start mct-items-stretch">
          <div class="light-text">{{ 'profiles.view.tasks.assigned-to' | translate | titlecase }}</div>
          <div>
            {{ task.AssignedToUserName }}
          </div>
        </div>
        <div   class="mb-6 mct-flex mct-col mct-justify-start mct-items-stretch">
          <div class="light-text">{{ 'profiles.view.tasks.assigned-by' | translate | titlecase }}</div>
          <div>
            {{ task.AssignedByUserName }}
          </div>
        </div>
        <div   class="mb-6 mct-flex mct-col mct-justify-start mct-items-stretch">
          <div class="light-text">{{ 'profiles.view.tasks.date-due' | translate | titlecase }}</div>
          <div>
            {{ task.DateDue | date : 'M/d/yyyy' }}
          </div>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-progressSpinner *ngIf="loading"></p-progressSpinner>
<wl-page-size-dropdown
  [(pageSize)]="searchParams.PageSize"
  [pageSizes]="[10, 0]"
  (pageSizeChange)="pageSizeChanged()"
></wl-page-size-dropdown>

<wl-task-edit-dialog #taskEditDialog (taskSaved)="search()"></wl-task-edit-dialog>

<wl-task-generate-dialog #taskGenerate></wl-task-generate-dialog>

<p-confirmDialog #deleteTaskCD key="deleteTaskCD">
  <ng-template pTemplate="footer">
    <button pButton type="button" (click)="deleteTaskCD.reject()" class="atlas-btn atlas-btn-secondary mr-10">{{ rejectText }}</button>
    <button pButton type="button" (click)="deleteTaskCD.accept()" class="atlas-btn atlas-btn-primary">{{ acceptText }}</button>
  </ng-template>
</p-confirmDialog>
